// extracted by mini-css-extract-plugin
export default {"background":"styles_background__sZR6J","backgroundPattern":"styles_backgroundPattern__rm+xZ","backgroundPatternImage":"styles_backgroundPatternImage__DyXg-"};